import { useEffect, useRef } from 'react'
import { useGoogleAuth } from '../hooks/useGoogleAuth'

interface GoogleSignInButtonProps {
  clientId: string
  theme?: 'outline' | 'filled_blue' | 'filled_black'
  size?: 'large' | 'medium' | 'small'
  type?: 'standard' | 'icon'
  shape?: 'rectangular' | 'pill'
  text?: 'signin_with' | 'continue_with'
  width?: number
  onSuccess?: () => void
  onError?: (error: Error) => void
  className?: string
}

export default function GoogleSignInButton({
  clientId,
  theme = 'outline',
  size = 'large',
  type = 'standard',
  shape = 'rectangular',
  text = 'signin_with',
  width,
  onSuccess,
  onError,
  className = ''
}: GoogleSignInButtonProps) {
  console.log('🔵 GoogleSignInButton rendered with clientId:', clientId)
  const buttonRef = useRef<HTMLDivElement>(null)
  const { renderSignInButton, isLoading, error } = useGoogleAuth({
    clientId,
    enableOneTap: false, // Don't enable One Tap for individual buttons
    onSuccess,
    onError
  })

  useEffect(() => {
    if (!isLoading && buttonRef.current && clientId) {
      console.log('🔵 Rendering Google Sign-In button...')
      renderSignInButton(buttonRef.current, {
        theme,
        size,
        type,
        shape,
        text,
        width
      })
    } else {
      console.log('🟡 Not rendering button - loading:', isLoading, 'hasRef:', !!buttonRef.current, 'hasClientId:', !!clientId)
    }
  }, [isLoading, clientId, theme, size, type, shape, text, width, renderSignInButton])

  if (isLoading) {
    return (
      <div className={`flex items-center justify-center p-3 border border-gray-300 rounded ${className}`}>
        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-600"></div>
        <span className="ml-2 text-sm text-gray-600">Loading...</span>
      </div>
    )
  }

  if (error) {
    return (
      <div className={`p-3 border border-red-300 rounded bg-red-50 ${className}`}>
        <p className="text-sm text-red-600">Failed to load Google Sign-In</p>
      </div>
    )
  }

  return (
    <div 
      ref={buttonRef} 
      className={className}
      style={{ width: width ? `${width}px` : 'auto' }}
    />
  )
}